export const SEARCHING_COUNTRY_SELECTION = [
  'visible.harmonized_system_classification_code.harmonized_system_code_country',
  'tradeItem.countryOfOriginAssembly',
  'orderable.stateRestrictions.states',
];
